import { WebPlugin } from '@capacitor/core';
export class BackgroundstepWeb extends WebPlugin {
    checkAndRequestPermission() {
        throw new Error('Method not implemented.');
    }
    serviceStart() {
        throw new Error('Method not implemented.');
    }
    serviceStop() {
        throw new Error('Method not implemented.');
    }
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
    async getToday() {
        return {
            count: 0
        };
    }
    ;
    async getStepData(options) {
        console.log('TERM', options);
        return {
            count: 0
        };
    }
}
//# sourceMappingURL=web.js.map